import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRouter from './components/appRouter';
import store from './redux/store.ts';
import ErrorBoundary from './components/errorBoundary';
import { validateFrontendEnv } from './config/env';
import { initializeMonitoring } from './config/monitoring';
import { routerFutureConfig } from './config/routerFuture';
import { installPayPalScriptErrorSuppression } from './utils/paypal';

validateFrontendEnv();
initializeMonitoring();
installPayPalScriptErrorSuppression();

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router future={routerFutureConfig}>
        <ErrorBoundary>
          <AppRouter />
        </ErrorBoundary>
      </Router>
    </Provider>
  </React.StrictMode>
);
